import { render, staticRenderFns } from "./subAccount.vue?vue&type=template&id=e1b08aa8&scoped=true&"
import script from "./subAccount.vue?vue&type=script&lang=js&"
export * from "./subAccount.vue?vue&type=script&lang=js&"
import style0 from "./subAccount.vue?vue&type=style&index=0&id=e1b08aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b08aa8",
  null
  
)

export default component.exports